
import React, { Component } from 'react';
import './App.css';
import Container from "./Components/Common/Containers/Container";
import { HelmetProvider } from 'react-helmet-async';
import 'antd/dist/antd.css'
import { createTheme, ThemeProvider } from '@material-ui/core'

const App = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#6CAAA8',
      },
    },
  })
  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <Container />
      </HelmetProvider>
    </ThemeProvider>


  );
}

export default App;
